export enum TabsEnumMachineCenterDetails {
    configuration,
    failureCodes,
}
